<template>
	<nk-wrapper v-if="context" spacing="md">
		<nk-accordion :title="context.titel || 'Kontakt'" title-size="xl" open>
			<nk-row>
				<nk-col cols="shrink" class="hidden sm:block">
					<nk-icon
						:icon="context.ansprechpartner ? 'user' : 'map'"
						size="2xl"
						:inline="false"
						:background-color="true"
						color="neutral"
						variant="boxed"
					/>
				</nk-col>
				<nk-col cols="auto">
					<nk-title
						v-if="context.ansprechpartner"
						size="lg"
						color="type-dark"
						font-weight="semibold"
					>
						{{ context.ansprechpartner }}
					</nk-title>
					<nk-address
						variant="vertical"
						v-bind="{...context.adresse, ...context.kontakt}"
					/>
				</nk-col>
			</nk-row>
		</nk-accordion>
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {string} context.titel
 * @prop {string} context.ansprechpartner
 * @prop {object} context.adresse
 * @prop {object} context.kontakt
 */
export default {
	name: 'NkTemplateKontakt',
	mixins: [TemplatesDefault],
};
</script>
